/* eslint-disable jsx-a11y/heading-has-content */
import React, { ReactElement } from 'react';
import { CardBox } from 'b2b-components/theme/components/CardBox';

const Skeleton = (): ReactElement => (
  <React.Fragment>
    <CardBox className='CheckoutBox'>
      <h2 className='cds-Skeleton--TextH2 cds-Skeleton--TextMedium' />

      <div className='CartSummaryBox-Prices'>
        <div className='CartSummaryBox-PriceItem'>
          <span className='cds-Skeleton--TextMedium' />
          <span className='cds-Skeleton--TextShort' />
        </div>

        <div className="CartSummaryBox-PriceItem">
          <span className="cds-Skeleton--TextMedium" />
          <span className="cds-Skeleton--TextShort" />
        </div>

        <div className="CartSummaryBox-PriceItem">
          <span className="cds-Skeleton--TextShort" />
          <span className="cds-Skeleton--TextShort" />
        </div>

        <div className="CartSummaryBox-PriceItem CartSummaryBox-PriceItem--Total">
          <span className='cds-Skeleton--TextMedium' />
          <span className='cds-Skeleton--TextShort' />
        </div>
      </div>

      <div className='CartSummaryBox-Bottom cds-Skeleton--Button' />
    </CardBox>
  </React.Fragment>
);

export { Skeleton };
